import Router from 'vue-router'
import Vue from 'vue'
import { loadLanguageAsync } from '@/i18n'
import ptMeta from '@/meta/ptMeta'
import enMeta from '@/meta/enMeta'
import esMeta from '@/meta/esMeta'
import cnMeta from '@/meta/cnMeta'

function load (component) {
  return () => import(`@/views/${component}.vue`)
}

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      component: load('home'),
      meta: ptMeta
    },
    {
      path: '/home',
      name: 'home',
      component: load('home'),
      meta: ptMeta
    },
    {
      path: '/home/:lang',
      name: 'home-lang',
      props: true,
      component: load('home')
    },
    {
      path: '/legal-advice/:lang',
      name: 'legal-advice-lang',
      component: load('legal-advice')
    },

    {
      path: '/modern-slavery/:lang',
      name: 'modern-slavery-lang',
      component: load('modern-slavery')
    },
    {
      path: '/green-politic/:lang',
      name: 'green-politic-lang',
      component: load('green-politic')
    },
    {
      path: '/anti-corruption/:lang',
      name: 'anti-corruption-lang',
      component: load('anti-corruption')
    },
    {
      path: '/general-politic/:lang',
      name: 'general-politic-lang',
      component: load('general-politic')
    },

    {
      path: '/404',
      name: 'not-found-page',
      component: load('not-found')
    },
    {
      path: '*',
      name: 'not-found',
      redirect: '/404'
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return savedPosition
    else if (to.hash) return { selector: to.hash }
    else return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  let defaultLanguage
  let pageTitle
  let metaTags
  if (to.name === 'legal-advice' || from.name === 'legal-advice') {
    await loadLanguageAsync('pt')
  } else {
    defaultLanguage = 'pt'
    let lang = to.params.lang || defaultLanguage
    await loadLanguageAsync(lang)
  }
  if (to.name === 'home-lang') {
    const language = to.path.substring(to.path.lastIndexOf('/'))
    switch (language) {
    case '/pt':
      pageTitle = ptMeta.title
      metaTags = ptMeta.metaTags
      break
    case '/en':
      pageTitle = enMeta.title
      metaTags = enMeta.metaTags
      break
    case '/es':
      pageTitle = esMeta.title
      metaTags = esMeta.metaTags
      break
    case '/cn':
      pageTitle = cnMeta.title
      metaTags = cnMeta.metaTags
      break
    }
  } else {
    pageTitle = to.meta && to.meta.title
    metaTags = to.meta && to.meta.metaTags
  }
  if (pageTitle) document.title = pageTitle
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))
  if (!metaTags) return next()
  metaTags.map(tagDef => {
    const tag = document.createElement('meta')
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })
    tag.setAttribute('data-vue-router-controlled', '')
    return tag
  }).forEach(tag => {
    document.head.appendChild(tag)
  })
  return next()
})

export default router
